const processStatus = (status: string) => {
  let dictionary: any = {
    'Uploaded': (
      <div className="flex mt-.5 items-center">
        <div className="relative inline-flex">
          <span className="flex">
            <span className="relative inline-flex rounded-full h-3 w-3 bg-purple-500"></span>
          </span>
        </div>
        <div className="w-5/6 text-left ml-2">
          <div className="text-sm text-gray-500">Uploaded</div>
        </div>
      </div>
    ),
    'Deployed': (
      <div className="flex mt-.5 items-center">
        <div className="relative inline-flex">
          <span className="flex">
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-300"></span>
          </span>
        </div>
        <div className="w-5/6 text-left ml-2">
          <div className="text-sm font-semibold text-gray-500">Deployed</div>
        </div>
      </div>
    ),
    'Unknown': (
      <div className="flex mt-.5 items-center">
        <div className="w-5/6 text-left mr-2">
          <div className="text-sm font-semibold text-gray-500">Unknown</div>
        </div>
        <div className="relative inline-flex">
          <span className="flex">
            <span className="relative inline-flex rounded-full h-3 w-3 bg-gray-600"></span>
          </span>
        </div>
      </div>
    ),
  }
  return dictionary[status];
}

const VersionStatus = (props: any) => {
  return (
    <div className="px-3 whitespace-nowrap flex justify-start">
      {
        processStatus(props.status ? props.status : 'Unknown')
      }
    </div>
  )
}

export default VersionStatus;
